<template>
    <div class="map-box" ref="mapContainer"></div>
</template>

<script>
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

export default {
    props: {
        center: Array
    },
  components: {

  },
  data() {
    return {
      accessToken: window.MAPBOX_API_KEY, // your access token. Needed if you using Mapbox maps
      mapStyle: 'mapbox://styles/mapbox/streets-v12', // your map style,
      mapBox: null
    };
  },

  mounted() {
    mapboxgl.accessToken = this.accessToken;
    const map = new mapboxgl.Map({
      container: this.$refs.mapContainer,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: this.center,
      zoom: 5
    });

    new mapboxgl.Marker({ color: 'red' })
        .setLngLat(this.center)
        .addTo(map);
    map.addControl(new mapboxgl.FullscreenControl());
    map.addControl(new mapboxgl.NavigationControl());
  }
};
</script>

<style scoped>
  .map-box{
    height: 100%;
  }
</style>
